/* global React */
function AboutScreen() {
  return (
    <div className="about-screen">
      <div className="about-hero">
        <div className="about-kicker">Since 2008 · Costa Rica</div>
        <h1 className="about-title">Maps that started on paper.</h1>
        <p className="about-lede">
          CRMaps grew out of the illustrated tourist maps you've seen in cafés, hotel lobbies and beach shops across the country — now connected, updated, and in your pocket.
        </p>
      </div>

      <div className="about-card">
        <h3>What we make</h3>
        <p>
          Hand-drawn maps of Costa Rica's best regions, paired with a directory of local businesses, real-time tide charts, and a wallet of discount &amp; loyalty passes that work across the network.
        </p>
        <p>
          The illustrators are the same artists who paint our printed maps. The platform just makes them tappable.
        </p>
      </div>

      <div className="about-stats">
        <div className="about-stat">
          <div className="v">1,250+</div>
          <div className="l">Local spots</div>
        </div>
        <div className="about-stat">
          <div className="v">24</div>
          <div className="l">Regions mapped</div>
        </div>
        <div className="about-stat">
          <div className="v">18 yrs</div>
          <div className="l">On the road</div>
        </div>
      </div>

      <div className="about-timeline">
        <h3>Our story</h3>
        <div className="tl-item">
          <div className="tl-year">2008</div>
          <div className="tl-body">
            <h4>First printed map</h4>
            <p>A hand-illustrated Manuel Antonio guide, distributed free at hotels.</p>
          </div>
        </div>
        <div className="tl-item">
          <div className="tl-year">2014</div>
          <div className="tl-body">
            <h4>The full coast</h4>
            <p>Tamarindo, Jacó, Uvita, Puerto Viejo and 12 more regions added.</p>
          </div>
        </div>
        <div className="tl-item">
          <div className="tl-year">2019</div>
          <div className="tl-body">
            <h4>Maps go digital</h4>
            <p>First interactive map viewer launches — same artwork, now zoomable.</p>
          </div>
        </div>
        <div className="tl-item">
          <div className="tl-year">2024</div>
          <div className="tl-body">
            <h4>Loyalty passes</h4>
            <p>CRMaps Pass introduces stored discounts &amp; stamps across partner businesses.</p>
          </div>
        </div>
        <div className="tl-item">
          <div className="tl-year">2026</div>
          <div className="tl-body">
            <h4>The connected guide</h4>
            <p>Tide charts, Waze, and a new directory bring the whole experience together.</p>
          </div>
        </div>
      </div>

      <div className="about-cta">
        <div className="small">Be on the map</div>
        <h3>List your business</h3>
        <p>Hotels, restaurants, tour operators — get featured on the printed and digital editions, with optional pass &amp; loyalty cards.</p>
        <button className="about-cta-btn">Get in touch →</button>
      </div>
    </div>
  );
}

Object.assign(window, { AboutScreen });
